import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18n';
import { pinRecovery } from 'actions/profile';
import { getContractNumberSelector } from 'reducers/profile/selectors';
import Header from '../common/Header';
import EmailForm from '../common/EmailForm';

const i18nScope = 'authorizationRestorePinEmailPage';
const SECTION_NAME = 'EMAIL_INPUT';

const AuthorizationRestorePinEmailPage = () => {
  const dispatch = useDispatch();
  const contractNumber = useSelector(getContractNumberSelector);
  const onSubmit = useCallback(
    (email) => dispatch(pinRecovery({ email, contractNumber, errorModal: { returnFocusTo: `@${SECTION_NAME}` } })),
    [contractNumber, dispatch],
  );

  return (
    <>
      <Header title={i18n.t(`${i18nScope}.title`)} description={i18n.t(`${i18nScope}.description`)} />
      <EmailForm
        initialValue={''}
        placeholder={i18n.t(`${i18nScope}.emailPlaceholder`)}
        invalidMessage={i18n.t(`${i18nScope}.emailInvalid`)}
        analyticsEventGroup={'credentials recovery screen'}
        analyticsEventName={'click send password'}
        buttonLabel={i18n.t(`${i18nScope}.next`)}
        sectionName={SECTION_NAME}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default AuthorizationRestorePinEmailPage;
